import { render, staticRenderFns } from "./bkv-editor.vue?vue&type=template&id=4ea8cd08&scoped=true"
import script from "./bkv-editor.vue?vue&type=script&lang=js"
export * from "./bkv-editor.vue?vue&type=script&lang=js"
import style0 from "./bkv-editor.vue?vue&type=style&index=0&id=4ea8cd08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8cd08",
  null
  
)

export default component.exports